import barberCraftLogo from "@/assets/barber-craft-logo.webp";
import antonioAvatar from "@/assets/antonio-barbercraft-founder.webp";
import {
  Attribution,
  QuoteCard,
  useInViewRef,
} from "@/components/sections/testimonial/shared";

export function Step5Testimonial() {
  const { ref } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="flex flex-col">
      <h2 className="text-4xl font-bold tracking-tight text-foreground">
        Started with zero. Left with a{" "}
        <span className="text-gradient-cycle font-bold">brand.</span>
      </h2>

      <QuoteCard>
        I had no logo, no colors, nothing. They built the whole look from
        scratch and it felt like{" "}
        <span className="text-gradient-cycle font-bold">me immediately.</span>
      </QuoteCard>

      <Attribution
        avatarSrc={antonioAvatar}
        avatarAlt="Antonio Da Costa"
        name="Antonio Da Costa"
        role="Owner, Barber Craft San Diego"
        logoSrc={barberCraftLogo}
        logoAlt="Barber Craft logo"
      />
    </section>
  );
}
